<template>
  <div>
    <v-card
      tile
      flat
      dark
      color="#277FAF"
      width="100%"
      :max-width="maxWidth"
      class="mx-auto pa-5 f14 fw500 d-flex justify-space-between flex-wrap gap4"
    >
      <div class="line-height-3 d-flex flex-column flex-md-row flex-wrap gap4">
        <div>
          <div>{{ t.project }}</div>
          <div>{{ project.name }}</div>
        </div>
        <div>
          <div>{{ t.address }}</div>
          <div>{{ project.street + ', ' + project.zip + ', ' + project.city }}</div>
        </div>
        <div>
          <div>{{ t.term }}</div>
          <div>{{ date }}</div>
        </div>
      </div>
      <div>
        <v-btn
          @click="changePage"
          :elevation="4"
          :disabled="
            Object.values(totalCheckbox).every((cur) => {
              return cur.approved === false
            })
          "
        >
          <IconTimeControlConfirm />
        </v-btn>
      </div>
    </v-card>
    <div v-if="totalWorkTypes.length || totalExtras.length || employees.length" >
    <div class="horizontalScroll mb-5">
      <v-card
        v-if="totalWorkTypes.length || totalExtras.length"
        tile
        flat
        width="100%"
        :min-width="minWidth"
        :max-width="maxWidth"
        class="pa-5 mx-auto"
      >
        <StatisticProjectReportsBlankTable>
          <StatisticProjectReportsBlankExcelTableHeader :col-name="t.position" total />
          <StatisticProjectReportsBlankExcelTableTotal
            :works="Object.values(totalWorkTypes)"
            :extras="Object.values(totalExtras)"
          />
        </StatisticProjectReportsBlankTable>
      </v-card>
     <Plug v-else/>
    </div>
    <div v-for="(employee, e) in employees" :key="'employee' + e" class="horizontalScroll mb-5">
      <v-card
        :class="
          'pa-5 fw500 mx-auto d-flex flex-wrap ' + ($vuetify.breakpoint.smAndDown ? 'f12' : 'f14')
        "
        width="100%"
        :min-width="minWidth"
        :max-width="maxWidth"
        tile
        flat
        dark
        color="#277FAF"
      >
        <div class="mr-10">{{ t.employee + ':' }}</div>
        <div>{{ employee.first_name + ' ' + employee.last_name }}</div>
      </v-card>
      <v-card
        class="mx-auto pa-5"
        width="100%"
        :min-width="minWidth"
        :max-width="maxWidth"
        tile
        flat
      >
        <StatisticProjectReportsBlankTable>
          <StatisticProjectReportsBlankExcelTableHeader :col-name="t.position" total />
          <StatisticProjectReportsBlankExcelTableTotal
            :works="Object.values(employee.work_types)"
            :extras="Object.values(employee.extras)"
          />
        </StatisticProjectReportsBlankTable>
      </v-card>
      <v-card
        class="mx-auto pa-5"
        width="100%"
        :min-width="minWidth"
        :max-width="maxWidth"
        tile
        flat
      >
        <StatisticProjectReportsBlankTable :key="e">
          <StatisticProjectReportsBlankExcelTableHeader :col-name="t.date">
            <BaseCheckbox
              slot="first"
              v-model="totalCheckbox[e].approved"
              @input="changeValue(totalCheckbox[e].approved, e, false)"
              :disabled="totalCheckbox[e].signed"
            />
          </StatisticProjectReportsBlankExcelTableHeader>
          <StatisticProjectReportsBlankExcelTableByDays :data="employee" :on-update="onUpdate" />
        </StatisticProjectReportsBlankTable>
      </v-card>
    </div>
    <div class="fixedBtn">
      <v-btn
        @click="changePage"
        :elevation="0"
        fab
        :width="$vuetify.breakpoint.smAndDown ? 45 : 60"
        :height="$vuetify.breakpoint.smAndDown ? 45 : 60"
        v-if="
          !Object.values(totalCheckbox).every((cur) => {
            return cur.approved === false
          })
        "
      >
        <IconTimeControlConfirm :width="$vuetify.breakpoint.smAndDown ? 35 : 45" />
      </v-btn>
    </div>
  </div>
   <Plug class="my-10" v-else/>
  </div>
</template>

<script>
import StatisticProjectReportsBlankTable from '../StatisticProjectReportsBlankTable'
import StatisticProjectReportsBlankExcelTableHeader from './StatisticProjectReportsBlankExcelTableHeader'
import StatisticProjectReportsBlankExcelTableTotal from './StatisticProjectReportsBlankExcelTableTotal'
import StatisticProjectReportsBlankExcelTableByDays from './StatisticProjectReportsBlankExcelTableByDays'
import BaseCheckbox from '../../../../base/BaseCheckbox'
import IconTimeControlConfirm from '../../../../icons/timeControl/IconTimeControlConfirm'
import Plug from 'components/Plug.vue'

export default {
  name: 'StatisticProjectReportsBlankExcelTable',
  components: {
    Plug,
    IconTimeControlConfirm,
    BaseCheckbox,
    StatisticProjectReportsBlankExcelTableByDays,
    StatisticProjectReportsBlankExcelTableTotal,
    StatisticProjectReportsBlankExcelTableHeader,
    StatisticProjectReportsBlankTable,
  },
  props: {
    project: {
      type: Object,
      default: () => {
        return {}
      },
    },
    date: {
      type: String,
      default: '',
    },
    totalWorkTypes: {
      type: Array,
      default: () => {
        return []
      },
    },
    totalExtras: {
      type: Array,
      default: () => {
        return []
      },
    },
    employees: {
      type: Array,
      default: () => {
        return []
      },
    },
    onUpdate: {},
    onConfirmPage: {},
  },
  data: () => ({
    minWidth: 800,
    maxWidth: 1800,
  }),
  computed: {
    totalWorkTypesCount() {
      return Object.keys(this.totalWorkTypes).length
    },
    totalExtrasCount() {
      return Object.keys(this.totalExtras).length
    },
    reports() {
      let temp = []
      let fields = ['work_types', 'extras']
      for (let i in fields) {
        let name = fields[i]
        for (let e in this.employees) {
          let work = this.employees[e][name]
          for (let w in work) {
            let days = Object.values(work[w].days).map((data) => data.reports)
            for (let d in days) {
              for (let r in days[d]) {
                let item = days[d][r]
                item.employee_id = Number(e)
                item.is_hourly = work[w].is_hourly
                item.type = name
                temp.push(item)
              }
            }
          }
        }
      }
      return temp
    },
    totalCheckbox() {
      let temp = {}
      for (let e in this.employees) {
        let report = this.reports.filter((i) => i.employee_id === Number(e))
        let check = { approved: null, paid: null, signed: null }
        for (let field in check) {
          let signed = field === 'signed'
          let value = report.every((current) => {
            return signed
              ? current['client_report_status'] !== null
              : Number(current[field + '_report']) > 0
          })
            ? true
            : report.every((current) => {
                return signed
                  ? current['client_report_status'] === null
                  : Number(current[field + '_report']) === 0
              })
            ? false
            : null
          if (!temp[e]) temp[e] = {}
          temp[e][field] = value
        }
      }
      return temp
    },
    t() {
      return this.localStorage.translations.pages.finance['period-table']
    },
  },
  methods: {
    async changeValue(value, key, paid) {
      let field = paid ? 'paid' : 'approved'
      let temp = this.reports.filter((i) => i.employee_id === Number(key))
      let work = []
      let extra = []
      for (let i in temp) {
        let item = {}
        let val = value
          ? temp[i]['paid_report'] || temp[i]['approved_report'] || temp[i]['employee_report']
          : 0
        item.id = temp[i].id
        temp[i].is_hourly === 1 || temp[i].type === 'extras'
          ? (item[field + '_hours'] = val)
          : (item[field + '_size'] = val)
        item[field + '_notes'] = value ? temp[i][field + '_notes'] || '' : ''
        if (paid) {
          if (temp[i]['client_report_status'] === 'signed')
            temp[i].type === 'work_types' ? work.push(item) : extra.push(item)
        } else {
          if (temp[i]['client_report_status'] === null)
            temp[i].type === 'work_types' ? work.push(item) : extra.push(item)
        }
      }
      if (this.onUpdate) {
        this.onUpdate(work, value, paid, false)
        this.onUpdate(extra, value, paid, true)
      }
    },

    changePage() {
      if (this.onConfirmPage) this.onConfirmPage(true)
    },
  },
}
</script>

<style scoped lang="scss">
.gap4 {
  gap: 16px;
}

.horizontalScroll {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    overflow-x: scroll;
    max-width: 93vw;
  }
}

:deep() .grid {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 80px 1fr;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    grid-template-columns: 60px 1fr;
  }

  &_header {
    @extend .grid;
    grid-template-columns: 80px 340px 1fr 1fr 1fr;
    background-color: #f2f2f2;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      grid-template-columns: 60px 200px 1fr 1fr 1fr;
    }
  }

  &_inner {
    @extend .grid;
    grid-template-columns: 170px 170px 1fr 1fr 1fr;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      grid-template-columns: 100px 100px 1fr 1fr 1fr;
    }
  }

  .grid_quantity {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

.v-btn {
  background-color: #f2f2f2 !important;
  color: #277faf !important;
  border-radius: 15px !important;
  padding: 12px !important;
  transition-property: all;
  transition-duration: 0.5s;

  &:hover {
    background-color: white !important;
    box-shadow: none !important;
    transition-property: all;
    transition-duration: 0.5s;
  }
}

:deep() .one_col {
  grid-column: 3 / 6;
}
</style>